import {
	businessInfoService,
	asyncValidationService,
	webSiteService,
} from "services";

import { businessInfoConstants } from "./businessInfo.constants";

export const businessInfoActions = {
	setValue,
	setBanks,
	setBillingBanks,
	webSiteCheck,
	sendGeoLocation,
	updateWebSiteInformation,
};

function setValue(name, value) {
	return { type: businessInfoConstants.SET_VALUE, name, value };
}

function setBanks(banks) {
	return {
		type: businessInfoConstants.SET_BANKS,
		banks,
	};
}

function setBillingBanks(banks) {
	return {
		type: businessInfoConstants.SET_BILLING_BANKS,
		billingBanks: banks,
	};
}

function webSiteCheck(webSiteUrl) {
	return dispatch => {
		dispatch(request());

		return asyncValidationService.webSiteCheck(webSiteUrl).then(
			result => {
				dispatch(success(result, true));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function request() {
		return { type: businessInfoConstants.WEB_SITE_CHECK_REQUEST };
	}

	function success(website, isValidated) {
		return {
			type: businessInfoConstants.WEB_SITE_CHECK_SUCCESS,
			website,
			isValidated,
		};
	}

	function failure(error) {
		return { type: businessInfoConstants.WEB_SITE_CHECK_ERROR, error };
	}
}

function sendGeoLocation(payload) {
	return dispatch => {
		return businessInfoService.sendGeoLocation(payload).then(
			result => {
				dispatch(success(result));
				return Promise.resolve(result);
			},
			error => {
				dispatch(failure(error));
				return Promise.reject(error);
			},
		);
	};

	function success() {
		return {
			type: businessInfoConstants.SEND_GEO_LOCATION_SUCCESS,
		};
	}

	function failure(error) {
		return { type: businessInfoConstants.SEND_GEO_LOCATION_ERROR, error };
	}
}

function updateWebSiteInformation(applicationId, websiteInformation) {
	return dispatch => {
		dispatch(request());
		return webSiteService
			.updateWebSiteInformation(applicationId, websiteInformation)
			.then(
				result => {
					dispatch(success(result));
					return Promise.resolve(result);
				},
				error => {
					dispatch(failure(error));
					return Promise.reject(error);
				},
			);
	};

	function request() {
		return {
			type: businessInfoConstants.UPDATE_WEB_SITE_INFORMATION_REQUEST,
		};
	}

	function success() {
		return {
			type: businessInfoConstants.UPDATE_WEB_SITE_INFORMATION_SUCCESS,
		};
	}

	function failure(error) {
		return {
			type: businessInfoConstants.UPDATE_WEB_SITE_INFORMATION_ERROR,
			error,
		};
	}
}
